import {
  Avatar,
  Badge,
  Button,
  Flex,
  Icon,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Stack,
  Box
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FaEdit } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function DriversTable({ columnsData, tableData, onEdit }) {
  const transformedUserData = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.map((driver) => ({
      name: driver.name,
      email: driver.email,
      mobile: driver.mobile,
      status: driver.status ? "true" : "false",
      id: driver.id,
      clientCount: driver.clients?.length || 0,
      clientNames: driver.clients?.map(client => client.name).join(", ") || "No Clients",
    }));

  }, [tableData]);

  const columns = useMemo(
    () => [
        {
          Header: "ΟΝΟΜΑ",
          accessor: "name",
              Cell: ({ value }) => {
                const fullName = value?.trim() || "";
                const nameParts = fullName.split(" ").filter(Boolean);
            
                let initials = "";
                if (nameParts.length === 1) {
                  initials = nameParts[0][0]?.toUpperCase() || "";
                } else if (nameParts.length >= 2) {
                  initials =
                    (nameParts[0][0] || "").toUpperCase() +
                    (nameParts[nameParts.length - 1][0] || "").toUpperCase();
                }
            
                return (
                  <Flex align="center" maxW="200px">
                    {initials && (
                      <Box
                        w="30px"
                        h="30px"
                        me="3"
                        borderRadius="full"
                        bg="teal.300"
                        color="white"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        fontSize="sm"
                        fontWeight="bold"
                      >
                        {initials}
                      </Box>
                    )}
                    <Text
                      isTruncated
                      maxW="120px"
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {fullName}
                    </Text>
                  </Flex>
                );
              },
            },    
      // {
      //   Header: "Driver Name",
      //   accessor: "name",
      //   Cell: ({ value }) => (
      //     <Flex align="center" maxW="200px">
      //       <Avatar name={value} w="30px" h="30px" me="3" />
      //       <Text
      //         isTruncated
      //         maxW="120px"
      //         whiteSpace="nowrap"
      //         overflow="hidden"
      //         textOverflow="ellipsis"
      //       >
      //         {value}
      //       </Text>
      //     </Flex>
      //   ),
      // },
      { Header: "Email", accessor: "email" },
      { Header: "ΤΗΛΕΦΩΝΟ", accessor: "mobile" },
      { Header: "ΑΡΙΘΜΟΣ ΠΕΛΑΤΩΝ", accessor: "clientCount" },
      {
        Header: "ΚΑΤΑΣΤΑΣΗ",
        accessor: "status",
        Cell: ({ value }) => {
          const isActive = value === true || value === "true" || value === 1;
          return (
            <Badge
              colorScheme={isActive ? "teal" : "red"}
              variant="subtle"
              borderRadius="full"
              px={3}
              py={1}
            >
              {isActive ? "Ενεργό" : "Ανενεργό"}
            </Badge>
          );
        },
      },


      // {
      //   Header: "Action",
      //   accessor: "action",
      //   Cell: ({ row }) => (
      //     <Flex gap={3}>
      //       <Icon
      //         as={FaEdit}
      //         color="blue.500"
      //         cursor="pointer"
      //         w="20px"
      //         h="20px"
      //         onClick={() => onEdit(row.original)}
      //       />
      //     </Flex>
      //   ),
      // },
    ],
    [columnsData, onEdit]
  );

  const data = useMemo(() => transformedUserData, [transformedUserData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
    getTableProps,
    gotoPage,
    pageCount,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = tableInstance;

  const { pageIndex, pageSize, globalFilter } = state;

  const createPages = (count) => {
    let arrPageCount = [];
    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }
    return arrPageCount;
  };

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex
        align={{ sm: "flex-start", lg: "flex-end" }}
        justify={{ sm: "flex-start", lg: "flex-end" }}
        w="100%"
        px="22px"
        mb="36px"
      >
        <Input
          type="text"
          placeholder="Αναζήτηση…"
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>

      <Flex overflowX="auto">
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead position="sticky" top="0" zIndex="1" bg="white">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize="12px"
                      color="gray.400"
                    >
                      {column.render("Header")}
                      <Icon
                        w="14px"
                        h="14px"
                        color={column.isSorted ? "gray.500" : "gray.400"}
                        as={
                          column.isSorted
                            ? column.isSortedDesc
                              ? TiArrowSortedDown
                              : TiArrowSortedUp
                            : TiArrowUnsorted
                        }
                      />
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  onClick={() => onEdit(row.original)}
                  cursor="pointer"
                  _hover={{ bg: "gray.50" }}
                >
                  {row.cells.map((cell, index) => (
                    <Td {...cell.getCellProps()} key={index} fontSize="14px" minW="150px">
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>

      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        px="22px"
        w="100%"
        px={{ md: "22px" }}
      >
        <Text fontSize="sm" color="gray.500" fontWeight="normal" mb={{ sm: "24px", md: "0px" }}>
          Showing {pageSize * pageIndex + 1} to{" "}
          {pageSize * (pageIndex + 1) <= tableData.length
            ? pageSize * (pageIndex + 1)
            : tableData.length}{" "}
          of {tableData.length} entries
        </Text>

        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button
            variant="no-hover"
            onClick={() => previousPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="50%"
            bg="#fff"
            border="1px solid lightgray"
            display={canPreviousPage ? "flex" : "none"}
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormPrevious} w="16px" h="16px" color="gray.400" />
          </Button>
          {createPages(pageCount).map((pageNumber, index) => (
            <Button
              variant="no-hover"
              transition="all .5s ease"
              onClick={() => gotoPage(pageNumber - 1)}
              w="40px"
              h="40px"
              borderRadius="160px"
              bg={pageNumber === pageIndex + 1 ? "teal.300" : "#fff"}
              border="1px solid lightgray"
              _hover={{
                bg: "gray.200",
                opacity: "0.7",
                borderColor: "gray.500",
              }}
              key={index}
            >
              <Text
                fontSize="xs"
                color={pageNumber === pageIndex + 1 ? "#fff" : "gray.600"}
              >
                {pageNumber}
              </Text>
            </Button>
          ))}
          <Button
            variant="no-hover"
            onClick={() => nextPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="160px"
            bg="#fff"
            border="1px solid lightgray"
            display={canNextPage ? "flex" : "none"}
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormNext} w="16px" h="16px" color="gray.400" />
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default DriversTable;
